import React, { useContext, useState } from "react";
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import { SortHeader, ServiceThreadSpinner, Pager } from ".";
import { constants, dateHelpers, UserContext } from "../utils";

export default function SalesCallTrackingGrid(props) {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [working, setWorking] = useState(false);

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  return (
    <>
      <Row className="align-items-center">
        <Col className="transparent-background">
          <Pager
            callBack={props.pagerCallback}
            sizeCallback={props.sizeCallback ? props.sizeCallback : null}
            pageNumber={props.pageNumber}
            pageSize={props.pageSize ? props.pageSize : null}
            totalPages={props.totalPages}
            allowAll={false}
            defaultPageSize={props.defaultPageSize}
          />
        </Col>
      </Row>
      <ServiceThreadSpinner on={working}>
        <Row className="align-items-center">
          <Col className="transparent-background">
            <ButtonGroup className="float-end">
              {props.salesCallTrackingData && props.salesCallTrackingData.length && props.exportXlsxCallback && (
                <Button
                  title="Download as .xlsx"
                  className="shredButtonExcel float-end ms-2"
                  onClick={getExcel}
                  disabled={working}
                >
                  <FontAwesomeIcon icon="file-excel" size="lg" />
                </Button>
              )}
            </ButtonGroup>
          </Col>
        </Row>
        <Table size="sm" className="data-table">
          <thead className="table-header">
            <tr>
              <th style={{ width: "12%" }}>
                <SortHeader
                  displayName="Sales Call #"
                  field="SalesCallDisplayId"
                  sortDirection={props.sortDirection}
                  sorted={props.sortField === "SalesCallDisplayId"}
                  callback={props.sortCallback}
                />
              </th>
              <th style={{ width: "7%" }}>
                <SortHeader
                  displayName={<span>Last<br />Action</span>}
                  field="LastActionDate"
                  sortDirection={props.sortDirection}
                  sorted={props.sortField === "LastActionDate"}
                  callback={props.sortCallback}
                />
              </th>
              <th style={{ width: "7%" }}>
                <SortHeader
                  displayName={<span>Contact<br />Type</span>}
                  field="CallTypeDescription"
                  sortDirection={props.sortDirection}
                  sorted={props.sortField === "CallTypeDescription"}
                  callback={props.sortCallback}
                />
              </th>
              {props.displayOnlyId === true ?
                <th style={{ width: "25%" }}>
                  <SortHeader
                    displayName="Customer"
                    field="CustomerId"
                    sortDirection={props.sortDirection}
                    sorted={props.sortField === "CustomerId"}
                    callback={props.sortCallback}
                  />
                </th> : null}
              {props.displayOnlyId === false ?
                <th style={{ width: "25%" }}>
                  <SortHeader
                    displayName="Customer"
                    field="CustomerIdName"
                    sortDirection={props.sortDirection}
                    sorted={props.sortField === "CustomerIdName"}
                    callback={props.sortCallback}
                  />
                </th>
                : null}
              <th style={{ width: "10%" }}>
                <SortHeader
                  displayName="Contact"
                  field="Contact"
                  sortDirection={props.sortDirection}
                  sorted={props.sortField === "Contact"}
                  callback={props.sortCallback}
                />
              </th>
              {props.displayOnlyId === true ?
                <th>
                  <SortHeader
                    displayName="Notes"
                    field="LastAction"
                    sortDirection={props.sortDirection}
                    sorted={props.sortField === "LastAction"}
                    callback={props.sortCallback}
                  />
                </th>
                : null}
              {props.displayOnlyId === false ?
                <th>
                  <SortHeader
                    displayName="Notes"
                    field="LastAction"
                    sortDirection={props.sortDirection}
                    sorted={props.sortField === "LastSaleActionNotes"}
                    callback={props.sortCallback}
                  />
                </th>
                : null}
            </tr>
          </thead>
          <tbody>
            {_.map(props.salesCallTrackingData, (datum, index) => {
              return (
                <tr
                  key={index}
                  className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                >
                  <td className="data-cell">
                    <span
                      className="shredLink fw-bold"
                      onClick={() => navigate(constants.ENDPOINTS.salesCallTrackingEdit + '/' + datum.trackingId)}
                    >
                      {datum.salesCallDisplayId}
                    </span>
                  </td>
                  <td className="data-cell" children={dateHelpers.toLongDateString(datum.lastActionDate)} />
                  <td className="data-cell" children={datum.callTypeDescription} />
                  {props.displayOnlyId === true ?
                    <td
                      className="data-cell"
                    >
                      <span
                      // className="shredLink fw-bold"
                      // onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: { value: datum.customerId, label: datum.customerIdName } })}
                      >
                        {datum.customerIdName}
                      </span>
                    </td>
                    : null}
                  {props.displayOnlyId === false ?
                    <td
                      className="data-cell"
                    >
                      <span
                        className="shredLink fw-bold"
                        onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: { value: datum.customerId, label: datum.customerIdName } })}
                      >
                        {datum.customerIdName}
                      </span>
                    </td>
                    : null}
                  <td className="data-cell" children={datum.contact} />
                  {props.displayOnlyId === true ?
                    <td className="data-cell" children={datum.notes} />
                    : null}
                  {props.displayOnlyId === false ?
                    <td className="data-cell" children={datum.notes} />
                    : null}
                  {props.displayOnlyId === false && currentUser && (currentUser.isAdmin || currentUser.isPowerUser)
                    ?
                    <td className="boldedOrange cursor-pointer" style={{ verticalAlign: "middle" }} onClick={() => props.onDelete(datum.trackingId)}>
                      Delete
                    </td>
                    : null
                  }
                  {props.displayOnlyId === false && currentUser && (currentUser.isAdmin || currentUser.isPowerUser)
                    ?
                    <td className="boldedOrange cursor-pointer" style={{ verticalAlign: "middle" }} onClick={() => props.printFunction(datum.trackingId)}>
                      Print
                    </td>
                    : null
                  }
                </tr>
              );
            })}
          </tbody>
        </Table>
      </ServiceThreadSpinner>
    </>
    // : null
  );
}